export default __webpack_public_path__ + "static/media/intro-sec-img-1.8c26f077.webp";